function init() {
  const io = require('socket.io-client');
  this.socket = io(window.location.origin);
}

function on(event, cb) {
  this.socket.on(event, cb);
}

function emit(event, msg) {
  this.socket.emit(event, msg);
}

function removeAllListeners(events) {
  this.socket.removeAllListeners(events);
}

export { init, on, emit, removeAllListeners };


// WEBPACK FOOTER //
// client/common/SocketIO.js